'use client';
import cn from 'classnames';
import styles from './PickupReadyHint.module.scss';
import { BottomDrawer } from '@/atoms/BottomDrawer';
import { Button } from '@/atoms/Button';
import { HintIcon } from '@/atoms/HintIcon';
import { Modal } from '@/atoms/Modal';
import { ModalContentWrapper } from '@/atoms/ModalContentWrapper';
import { PICKUP_READY_CUTOFF_TIME } from '@/constants';
import { useAdaptiveLayout } from '@/hooks/useAdaptiveLayout';
import { useBodyScrollLock } from '@/hooks/useBodyScrollLock';
import { selectPickupReadyInterval, selectPickupWorktime } from '@/store';
import { getHoursLabel } from '@/utils/getHoursLabel';
import { useState } from 'react';
import { useSelector } from 'react-redux';

type PickupReadyHintProps = {
  className?: string;
};

export function PickupReadyHint({ className }: PickupReadyHintProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const pickupReadyInterval = useSelector(selectPickupReadyInterval);
  const pickupWorktime = useSelector(selectPickupWorktime);
  const { isTablet } = useAdaptiveLayout();
  const [showHint, setShowHint] = useState(false);
  useBodyScrollLock(showHint);

  const handleHintClick = () => {
    setShowHint(true);
  };

  const handleCloseHint = () => {
    setShowHint(false);
  };

  if (!pickupReadyInterval) return null;

  const hours = Math.ceil(pickupReadyInterval / 60);

  const hintContent = (
    <ModalContentWrapper title="Время выдачи заказов" onClose={handleCloseHint}>
      <div className={styles.hintContent}>
        <div className={styles.hintTexts}>
          <p className={styles.hintText}>
            Собираем заказ в течение {hours} {getHoursLabel(hours)} после
            оплаты. Если оплата прошла после {PICKUP_READY_CUTOFF_TIME} — заказ
            будет готов на следующий день.
          </p>
          {pickupWorktime && (
            <p className={styles.hintText}>Забрать можно {pickupWorktime}.</p>
          )}
        </div>
        <Button text="Понятно" onClick={handleCloseHint} variant="secondary" />
      </div>
    </ModalContentWrapper>
  );

  return (
    <div className={wrapperClassName}>
      <HintIcon onClick={handleHintClick} />
      <Modal
        className={styles.modal}
        active={showHint && !isTablet}
        onClose={handleCloseHint}
        showCloseButton
      >
        {hintContent}
      </Modal>
      <BottomDrawer active={showHint && !!isTablet} onClose={handleCloseHint}>
        {hintContent}
      </BottomDrawer>
    </div>
  );
}
